<template>
    <router-view v-cb-animate='true' @next="next()" :edit-mode="editMode" :key="$route.path">
    </router-view>
</template>
<script type="text/javascript">
  import { mapGetters } from 'vuex'
  export default {
    computed: {
      ...mapGetters([
        'current_checkout_step',
      ])
    },
    data() {
      return {
        editMode: false
      }
    },
    mounted() {
      if(this.$route.query.mode == "edit" || this.$route.query.mode == "empty") {
        this.editMode = true;
      } else {
        this.editMode = false;
      }
    },
    beforeRouteUpdate(to, from, next) {
      if(to.query.mode == "edit" || to.query.mode == "empty") {
        this.editMode = true;
      } else {
        this.editMode = false;
      }
      next();
    },
    methods: {
      next() {
        this.$store.dispatch('set_next_step');
        this.$router.push({name: this.current_checkout_step});
      }
    }
  }
</script>


// WEBPACK FOOTER //
// Checkout.vue?0c1e0b66